/* eslint-disable no-console */
import Joi from 'joi';
import api from '../api';
import * as Types from '../types';

/**
 * Get posts list from a year
 *
 * @async
 * @param {Object} queryParams
 * @param {string} queryParams.year
 * @param {Object} params
 * @param {Number|null} params.excludedEndSlotId
 * @param {Number|null} params.includedStartSlotId
 * @param {string|null} params.resourceId
 * @param {('Pending'|'Accepted'|'Refused')|null} params.status
 * @param {('RemoteWorking'|'Leave')|null} params.type
 * @return {Promise<{data: Array<Types.Post>}>}
 */

// Mock a 401 return
// export const mockUnauthorized = () => {
//   const error = new Error('Unauthorized');
//   error.response = {
//     status: 401,
//     data: {
//       message: 'Unauthorized',
//     },
//   };
//   throw error;
// };

export const getPostsList = async (queryParams, params) => {
  const result = await api.get(
    `/calendars/${queryParams.year}/posts`,
    { params },
  );

  // return mockUnauthorized();

  try {
    const dataSchema = Joi.array().items(Types.postSchema);
    await dataSchema.validateAsync(result?.data?.data);
  } catch (error) {
    console.error(error);
    throw new Error(`getPostsList result do not validate postSchema : ${error}`);
  }

  return result.data;
};

/**
 * Delete a post from its ID
 *
 * @async
 * @param {Object} queryParams
 * @param {string} queryParams.year
 * @param {string} queryParams.postId
 * @return {Promise} Response from API under Axios instance
 */
export const deletePost = (queryParams) => api.delete(
  `/calendars/${queryParams.year}/posts/${queryParams.postId}`,
);

/**
 * Accept a post by an admin
 *
 * @async
 * @param {Object} queryParams
 * @param {string} queryParams.year
 * @param {string} queryParams.postId
 * @return {Promise} Response from API under Axios instance
 */
export const postAcceptPost = (queryParams) => api.post(
  `/calendars/${queryParams.year}/posts/${queryParams.postId}:accept`,
);

/**
 * Refuse a post by an admin
 *
 * @async
 * @param {Object} queryParams
 * @param {string} queryParams.year
 * @param {string} queryParams.postId
 * @return {Promise} Response from API under Axios instance
 */
export const postRefusePost = (queryParams) => api.post(
  `/calendars/${queryParams.year}/posts/${queryParams.postId}:refuse`,
);
